(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upperdeckys-fellas-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = new Set();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let raf = null;

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const smooth = (value) => value * value * (3 - 2 * value);

    const setFinal = (root) => {
      const stage = root.querySelector('[data-ud-connecting-stage]');
      const stageWidth = stage?.clientWidth || 417;
      root.style.setProperty('--ud-connect-left-x', `${stageWidth * (341 / 1440)}px`);
      root.style.setProperty('--ud-connect-right-x', `${stageWidth * (-368 / 1440)}px`);
      root.setAttribute('data-ud-connecting-progress', '1.000');
    };

    const updateRoot = (root) => {
      const stage = root.querySelector('[data-ud-connecting-stage]');
      if (!stage) return;

      if (reducedMotion.matches) {
        setFinal(root);
        return;
      }

      const rect = root.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1;
      if (viewportWidth >= 750) return;

      const stageRect = stage.getBoundingClientRect();
      /* 1.26, not 0.58: while the hands are apart, each clip window shows its
         baked photo patch and the arm chopped by the window edge. At 0.58 that
         parked state stayed on screen until the section climbed 42% up the
         viewport and read as broken art. 1.26 runs the whole 0.24-tall travel
         window before the stage crosses the viewport's bottom edge, so on
         screen the arms are always already joined - matching what the
         prefers-reduced-motion path always showed. */
      const rawProgress = (viewportHeight * 1.26 - stageRect.top) / Math.max(viewportHeight * 0.24, 1);
      const progress = clamp(rawProgress, 0, 1);
      const eased = smooth(progress);
      const stageWidth = stage.clientWidth || 417;
      const leftTravel = stageWidth * (341 / 1440);
      const rightTravel = stageWidth * (368 / 1440);

      root.style.setProperty('--ud-connect-left-x', `${leftTravel * eased}px`);
      root.style.setProperty('--ud-connect-right-x', `${-rightTravel * eased}px`);
      root.setAttribute('data-ud-connecting-progress', progress.toFixed(3));
    };

    const update = () => {
      raf = null;
      roots.forEach((root) => {
        if (!root.isConnected) {
          roots.delete(root);
          return;
        }

        updateRoot(root);
      });
    };

    const requestUpdate = () => {
      if (raf !== null) return;
      raf = window.requestAnimationFrame(update);
    };

    const prepare = (scope = document) => {
      scope.querySelectorAll('[data-ud-connecting-hands-root][data-ud-connecting-hands-enabled="true"]').forEach((root) => {
        roots.add(root);
        updateRoot(root);
      });
      requestUpdate();
    };

    prepare();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    reducedMotion.addEventListener?.('change', requestUpdate);
    document.addEventListener('shopify:section:load', (event) => prepare(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
